import CustomEvent from 'custom-event';

export default {
  getUserLinkedEvent() {
    return new CustomEvent('user_linked');
  },
};



// WEBPACK FOOTER //
// ./src/factories/event.factory.js